import {
  AcademicCapIcon,
  CalendarDaysIcon,
  DocumentTextIcon,
  EnvelopeIcon,
  FlagIcon,
  Squares2X2Icon,
  UserGroupIcon,
  BanknotesIcon,
  TruckIcon,
  HeartIcon,
  GlobeAltIcon,
  ClipboardDocumentCheckIcon,
  MapIcon,
} from "@heroicons/react/24/outline";
export const workspaces = [
  {
    id: "notes",
    label: "Notes",
    to: "/notes",
    icon: DocumentTextIcon,
    group: "Work & planning",
    description: "Ideas, meeting notes and things to remember.",
  },
  {
    id: "calendar",
    label: "Calendar",
    to: "/calendar",
    icon: CalendarDaysIcon,
    group: "Work & planning",
    description: "Your schedule, availability and meeting preparation.",
  },
  {
    id: "mail",
    label: "Mail",
    to: "/mail",
    icon: EnvelopeIcon,
    group: "Work & planning",
    description: "Conversations, follow-ups and reviewed replies.",
  },
  {
    id: "documents",
    label: "Documents",
    to: "/documents",
    icon: DocumentTextIcon,
    group: "Work & planning",
    description: "Connected Docs, Drive files and Notion pages.",
  },
  {
    id: "trackers",
    label: "Task & bug trackers",
    to: "/trackers",
    icon: Squares2X2Icon,
    group: "Work & planning",
    description: "Urgent fixes, owners and overdue work.",
  },
  {
    id: "responsibilities",
    label: "Tasks & follow-ups",
    to: "/manage?view=responsibilities",
    icon: ClipboardDocumentCheckIcon,
    group: "Work & planning",
    description: "Promises, deadlines and the next action.",
  },
  {
    id: "learning",
    label: "Learning",
    to: "/learning",
    icon: AcademicCapIcon,
    group: "Learning & wellbeing",
    description: "Your journal, reading list and learning roadmap.",
  },
  {
    id: "challenges",
    label: "Challenges",
    to: "/challenges",
    icon: FlagIcon,
    group: "Learning & wellbeing",
    description: "Daily check-ins and progress toward your goals.",
  },
  {
    id: "routines",
    label: "Routines",
    to: "/manage?view=routines",
    icon: HeartIcon,
    group: "Learning & wellbeing",
    description: "Training, meals, activity logs and check-ins.",
  },
  {
    id: "plans",
    label: "Plans",
    to: "/plans",
    icon: MapIcon,
    group: "Life & family",
    description: "Trips, purchases and projects with practical next steps.",
  },
  {
    id: "people",
    label: "People",
    to: "/manage?view=people",
    icon: UserGroupIcon,
    group: "Life & family",
    description: "Important dates, relationships and keeping in touch.",
  },
  {
    id: "finance",
    label: "Money & subscriptions",
    to: "/manage?view=finance",
    icon: BanknotesIcon,
    group: "Life & family",
    description: "Recorded balances, payments and renewals.",
  },
  {
    id: "vehicles",
    label: "Vehicles",
    to: "/manage?view=vehicles",
    icon: TruckIcon,
    group: "Life & family",
    description: "Service history and maintenance reminders.",
  },
  {
    id: "research",
    label: "Research & schedules",
    to: "/manage?view=agent",
    icon: GlobeAltIcon,
    group: "Life & family",
    description: "Source-backed discoveries and recurring research.",
  },
];
export const workspaceTitle = (location) =>
  workspaces.find((w) => w.to === location.pathname + location.search)?.label ||
  workspaces.find((w) => w.to.split("?")[0] === location.pathname)?.label ||
  (location.pathname.startsWith("/meetings/")
    ? "Meeting workspace"
    : location.pathname.startsWith("/calendar/events/")
      ? "Calendar review"
      : location.pathname.startsWith("/challenges/")
        ? "Challenge"
        : location.pathname.startsWith("/plans/")
          ? "Plan"
          : location.pathname === "/preferences"
            ? "Settings & memory"
            : location.pathname === "/integrations"
              ? "Connections"
              : location.pathname === "/profile"
                ? "Account"
                : "Workspace");
